import { useHub } from "../lib/hubContent";
import { EditSectionButton } from "./HubEditor";
import Reveal from "./Reveal";

export default function Faith() {
  const c = useHub().section("faith");
  return (
    <section id="faith" data-testid="faith-section" className="relative bg-[#F9F6F0] text-[#2A2927] py-24 md:py-32">
      <EditSectionButton sectionKey="faith" label="Edit" />
      <div className="max-w-3xl mx-auto px-5 md:px-8 text-center">
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-amber-700/70 mb-8">{c.eyebrow}</p>
          <div className="w-10 h-px bg-amber-600/50 mx-auto mb-10" aria-hidden="true" />
          <blockquote>
            <p className="font-display italic text-2xl md:text-4xl leading-snug text-stone-800">
              "{c.quote}"
            </p>
            <cite className="not-italic font-hand text-xl md:text-2xl text-amber-700 mt-6 block rotate-[-1deg]">
              {c.cite}
            </cite>
          </blockquote>
          <p className="mt-10 text-base leading-relaxed text-stone-600 max-w-xl mx-auto">
            {c.body}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
